export function createCallback(el, handler) {
  if (typeof handler !== 'function') {
    throw new Error(
      '"v-blur"-Direktive verlang eine Funktion als Value; e.g.: v-blur="callback"'
    );
  }
  return function clickHandler(e) {
    if (!el.contains(e.target)) {
      handler();
    }
  };
}
